import { render, staticRenderFns } from "./PollBlock.vue?vue&type=template&id=e4530db0&scoped=true&"
import script from "./PollBlock.vue?vue&type=script&lang=js&"
export * from "./PollBlock.vue?vue&type=script&lang=js&"
import style0 from "./PollBlock.vue?vue&type=style&index=0&id=e4530db0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4530db0",
  null
  
)

export default component.exports